
define('jst!filefinder/_blankslate_search',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="file-finder-blankslate">\n  <%= message %>\n</div>\n');
 });

